module.exports = __webpack_public_path__ + "static/media/s_icon_02.35f03844.png";